import { logger } from '@origin-digital/reporting-client';
import { IContent, Severity, IError } from '../../login/interfaces';
import { get } from 'lodash';
import { getForgotPasswordUrl } from '../../login/services/urlService';

const content: IContent = require('../../../ts/content.json');

interface LoginError {
  alertError?: IError;
  passwordError?: string;
  navigateToErroPage?: boolean;
}

const handleLoginError = (errorCode: string, usernameOrState: string): LoginError => {
  // too much noise in logs for invalid user password
  if (errorCode !== 'invalid_user_password') {
    logger.error(
      `handleError invoked ${usernameOrState} and errorCode is ${errorCode}`,
      new Error(`${usernameOrState} and errorCode is ${errorCode}`),
    );
  }

  const error = get(content.errors, errorCode, content.errors.generic_error);
  if (errorCode === 'invalid_user_password') {
    const invalidUserPassword = `Sorry, email and password don't match.\n[Forgot your password?](${getForgotPasswordUrl()})`;
    return {
      passwordError: invalidUserPassword,
    };
  } else if (error.severity === Severity.CRITICAL) {
    return {
      navigateToErroPage: true,
    };
  } else {
    // not an ideal solution for setting links from json, should refactor to
    // something better
    if (errorCode === 'too_many_attempts') {
      error.body = error.body.replace('[link]', getForgotPasswordUrl());
    }
    return {
      alertError: error,
    };
  }
};

export { handleLoginError };
